module.exports = __webpack_public_path__ + "static/img/about-1.ba46c88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/about-1.svg
// module id = 1334
// module chunks = 4